"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationFactorSetHandler = void 0;
const tslib_1 = require("tslib");
const rxjs_1 = require("rxjs");
const MessageType_1 = require("../message/MessageType");
const Error_1 = require("../shared/Error");
const Util_1 = require("../shared/Util");
class AuthenticationFactorSetHandler {
    constructor(router, messagingClient) {
        this.router = router;
        this.messagingClient = messagingClient;
        this.authenticationFactorSetObservable = new rxjs_1.Subject();
        this.router.setHandler(MessageType_1.MessageType.AuthenticationFactorSetResponse, this);
    }
    authenticationFactorSet(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.messagingClient.send(request);
            const promise = (0, rxjs_1.firstValueFrom)(this.authenticationFactorSetObservable);
            yield Util_1.Util.promiseWithTimeout(promise);
            return Promise.resolve();
        });
    }
    handle(message) {
        if (this.isAuthenticationFactorSetResponse(message)) {
            this.authenticationFactorSetObservable.next();
        }
        else {
            this.authenticationFactorSetObservable.error(Error_1.CustomerAuthnError.MALFORMED_MESSAGE);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isAuthenticationFactorSetResponse(object) {
        return object.payload instanceof Object && "payload" in object && "messageID" in object.payload;
    }
}
exports.AuthenticationFactorSetHandler = AuthenticationFactorSetHandler;
//# sourceMappingURL=AuthenticationFactorSetHandler.js.map